import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Game} from '../../../../../shared/model/game';
import {GenericFormComponent} from '../../../../../shared/components/generic-form/generic-form.component';

@Component({
  selector: 'app-game-create',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    GenericFormComponent
  ],
  templateUrl: './game-create.component.html',
  styleUrl: './game-create.component.css'
})
export class GameCreateComponent {
  @Input() title: string = 'Aggiungi un nuovo gioco';
  @Input() showCancel: boolean = false;
  @Output() gameAdded: EventEmitter<Game> = new EventEmitter<Game>();
  @Output() gameCreated: EventEmitter<Game> = new EventEmitter<Game>();
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();
  addGameForm: FormGroup;
  fb: FormBuilder = inject(FormBuilder);

  constructor() {
    this.addGameForm = this.fb.group({
      gameName: ['', Validators.required],
      gameDescription: ['', Validators.required],
      gameType: ['RPG', Validators.required],
      minPlayers: ['', [Validators.required, Validators.min(1)]],
      maxPlayers: ['', [Validators.required, Validators.min(1)]],
      yearPublished: [null],
      playingTime: [null],
      minAge: [null],
      imageUrl: [''],
      thumbnailUrl: [''],
    });
  }

  onSubmit() {
    if (this.addGameForm.valid) {
      const formValue = this.addGameForm.value;
      const game: Partial<Game> = {
        gameName: formValue.gameName,
        gameDescription: formValue.gameDescription,
        gameType: formValue.gameType,
        minPlayers: Number(formValue.minPlayers),
        maxPlayers: Number(formValue.maxPlayers),
        approved: true,
        yearPublished: formValue.yearPublished ? Number(formValue.yearPublished) : undefined,
        playingTime: formValue.playingTime ? Number(formValue.playingTime) : undefined,
        minAge: formValue.minAge ? Number(formValue.minAge) : undefined,
        imageUrl: formValue.imageUrl || undefined,
        thumbnailUrl: formValue.thumbnailUrl || undefined,
      };
      this.gameAdded.emit(game as Game);
      this.gameCreated.emit(game as Game);
      this.addGameForm.reset({ gameType: 'RPG' });
    }
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
